<template>
  <div>
    <page-head :title="title" :btn-list="!isEdit && (isArea || isStreet) ? btnList : btnList1" :show-back="true"
      @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="table-data">
        <div class="verifyRecord">附件列表</div>
        <i-table :columns="tableHeader" :border="true" :loading="isTableLoading" :data="tableData" stripe>
          <template slot-scope="{ row, index }" slot="view">
            <span @click.stop="clickPic(row)">[查看]</span>
          </template>
        </i-table>
        <preview-img :currentIndex="0" :imgArr="showPreview.list" v-if="showPreview.show"
          v-on:closePreview="closePreview"></preview-img>
        <div class="page">
          <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
        </div>
      </div>
      <div class="table-data">
        <div class="verifyRecord">个税减免列表</div>
        <i-table :columns="tableHeader2" :border="true" :loading="isTableLoading2" :data="tableData2" stripe>
          <template slot-scope="{ row, index }" slot="view">
            <span @click.stop="clickPic2(row)">[查看]</span>
          </template>
        </i-table>
        <div class="page">
          <page :total="total2" :current="pageNum2" @on-change="pageChange2" show-total />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import pageHead from "../../../../components/head";
import PreviewImg from "@/components/previewImg";
import api from "../../../../api/index";
const { handleApply, PromiseFileList, PromiseFileList2 } = api;
export default {
  name: "applyDetail",
  components: {
    pageHead,
    PreviewImg
  },
  data() {
    return {
      btnList: [
        {
          name: "重置",
          type: "search",
        },
      ],
      title: "  附件",
      showPreview: {
        show: 0,
        list: [],
      }, //预览图片

      comList: [], // 回显list
      communityList: [], // 数据源list
      communityId: "", // 选中的commuId
      savedId: "",

      isEdit: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pageNum2: 1,
      pageSize2: 10,
      total2: 0,
      info: {
        applicantMode: 1,
      },
      tableData: [],
      tableData2: [],
      isTableLoading: false,
      isTableLoading2: false,
      tableHeader: [
        {
          title: "序号",
          type: "index",
          width: 80,
          // align: "center"
        },
        {
          title: "业务单号",
          key: "orderNo",
        },
        // {
        //   title: "名称",
        //   key: "attachmentName",
        // },
        {
          title: "附件名称",
          key: "attachmentName",
        },
        {
          title: "凭证",
          slot: "view",
          width: 100,
        },
      ],
      tableHeader2: [
        {
          title: "序号",
          type: "index",
          width: 90,
          // align: "center"
        },
        {
          title: "不动产单元号",
          key: "estateUnitNo",
        },
        // {
        //   title: "名称",
        //   key: "attachmentName",
        // },
        {
          title: "附件名称",
          key: "promiseFiledName",
        },
        {
          title: "凭证",
          slot: "view",
          width: 100,
        },
      ],
      isArea: true,
      isStreet: false,
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "search") {
        this.pageNum = 1;
        this.pageNum2 = 1;
        this.getFaceList();
        this.getFaceList2();
      }
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.show = 0;
    },
    clickPic(val) {

      if (val.attachmentUrl.indexOf('.pdf') > -1) {
        window.open(val.attachmentUrl);

      } else {
        this.showPreview.list = [];
        console.log(val);
        this.showPreview.list = [{ isHeight: true, path: val.attachmentUrl }]
        console.log(this.showPreview.list);
        this.showPreview.show = 1;
      }
    },
    clickPic2(val) {
      if (val.fileUrl.indexOf('.pdf') > -1) {
        window.open(val.fileUrl);

      } else {
        this.showPreview.list = [];
        this.showPreview.list = [{ isHeight: true, path: val.fileUrl }]
        this.showPreview.show = 1;
      }

    },
    pageChange(val) {
      this.pageNum = val;
      this.getFaceList();
    },
    pageChange2(val) {
      this.pageNum2 = val;
      this.getFaceList2();
    },


    async getFaceList() {
      try {
        let { orderNo: orderNo } = this.$route.query;
        this.isLoading = true;
        let res = await this.$post(PromiseFileList(`?orderNo=${orderNo}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`));
        if (res.isSucceed && res.rows) {
          this.tableData = res.rows;
          this.total = res.total;
        }
        console.log(this.tableData);
      } finally {
        this.isLoading = false;
      }
    },
    async getFaceList2() {
      try {
        let { id: id } = this.$route.query;
        this.isLoading2 = true;
        let res = await this.$get(PromiseFileList2, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          promiseId: id,
        });
        if (res.isSucceed && res.rows) {
          this.tableData2 = res.rows;
          this.total2 = res.total;
        }
        console.log(this.tableData);
      } finally {
        this.isLoading2 = false;
      }
    },
  },
  created() {
    this.getFaceList();
    this.getFaceList2();
  },
};
</script>
  
<style  scoped lang="less">
.content {
  margin: 20px;
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.detail {
  color: #666;
}

.headPicUrl {
  // display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 10px;
}

.success {
  color: #ff7b44;
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 530px);

  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .verifyRecord {
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 3px solid #ff794e;
    height: 16px;
    line-height: 16px;
  }
}

.upload {
  margin-right: 10px;
}

.uploadbox {
  width: 100px;
  height: 100px;
  border: 1px dashed #ddd;
  color: #b5b5b5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  font-size: 14px;

  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
  }
}

/deep/ .imgbox {
  margin: 0;
}
</style>